import React, { useState, useEffect } from 'react';

import Api from 'utils/api';

import styles from './ProductUnitTab.module.css';

const ProductUnitTab = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  // 모달 및 폼 상태
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ productUnitId: null, productUnitName: '' });

  useEffect(() => {
    fetchUnitList();
  }, []);

  // 1. 리스트 조회 (GET)
  const fetchUnitList = async () => {
    setLoading(true);

    const data = await Api.get('/product/unit');
    setUnits(data.productUnitList || []);
    setLoading(false);

  };

  const handleOpenModal = (mode, data = null) => {
    setIsEditMode(mode === 'edit');
    setFormData(data ? { ...data } : { productUnitId: null, productUnitName: '' });
    setIsModalOpen(true);
  };

  // 2. 저장 로직 (POST)
  const handleSave = async () => {
    if (!formData.productUnitName.trim()) {
      return alert("단위 이름을 입력해주세요.");
    }

    try {
      let response;

      if (isEditMode) {
        // 수정
        const requestBody = {
          productUnitId: formData.productUnitId,
          productUnitName: formData.productUnitName
        };

        response = await Api.patch('/product/unit', requestBody);

      } else {
        // 등록
        const requestBody = {
          productUnitName: formData.productUnitName
        };

        response = await Api.post('/product/unit', requestBody);
      }

      if (!response) return;

      alert(isEditMode ? "수정이 완료되었습니다." : "등록이 완료되었습니다.");
      setIsModalOpen(false);
      fetchUnitList();

    } catch (error) {
      console.error("통신 오류:", error);
      alert("서버와 통신 중 오류가 발생했습니다.");
    }
  };

  // 3. 삭제 로직 (DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm("이 단위를 삭제하시겠습니까?")) return;

    const data = await Api.delete(`/product/unit?productUnitId=${id}`)

    if (data.code === 200) {
      alert("삭제가 완료되었습니다.");
      fetchUnitList(); // 삭제 후 목록 최신화
    } else {
      alert(`삭제 실패: ${data.message || '오류가 발생했습니다.'}`);
    }

  };

  if (loading) return <div className={styles.centerMsg}>단위 정보를 불러오는 중...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <div className={styles.countInfo}>등록된 단위 <span className={styles.countNumber}>{units.length}</span></div>
        <button className={styles.addBtn} onClick={() => handleOpenModal('add')}>+ 단위 등록</button>
      </div>

      <div className={styles.cardGrid}>
        {units.map((f) => (
          <div key={f.productUnitId} className={styles.productUnitCard}>
            <div className={styles.cardHeader}>
              <div>
                <h3 className={styles.unitName}>{f.productUnitName}</h3>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button className={styles.editBtn} onClick={() => handleOpenModal('edit', f)}>수정</button>
              <button className={styles.deleteBtn} onClick={() => handleDelete(f.productUnitId)}>삭제</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{isEditMode ? '단위 수정' : '새 단위 등록'}</h3>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.formContainer}>
                <div className={styles.inputGroup}>
                  <label>단위 명칭</label>
                  <input
                    name="productUnitName"
                    value={formData.productUnitName}
                    onChange={(e) => setFormData({ ...formData, productUnitName: e.target.value })}
                    className={styles.modalInput}
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.cancelBtn} onClick={() => setIsModalOpen(false)}>취소</button>
              <button className={styles.saveBtn} onClick={handleSave}>저장하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductUnitTab;